import { useCallback } from 'react';
import { usePortletConfig } from 'js/components/system/Portlet';
import { useTranslations } from 'js/hooks/i18n';

export const parseError = ({ tk, error }) => {
    const {
        data: errData = {},
        reason,
        response: {
            data = errData
        } = {}
    } = error;
    const {
        errorCode,
        errorMessage,
        message
    } = data;

    return errorCode
        ? [`${tk}.${errorCode}`, errorMessage || message || reason]
        : ['playtech.mobile.system.error.default'];
};

export default () => {
    const { tkPrefix } = usePortletConfig();
    const t = useTranslations();

    return useCallback((error, errorKey) => {
        const tk = `${tkPrefix}error.${errorKey}`;
        return t(...parseError({ tk, error }));
    }, [tkPrefix, t]);
};
